import React from "react";
import { getAsset } from "../../utils/assets";
import { EAssetName, EData, EParams } from "../../interfaces/enum";
import classNames from "classnames";
import { getData } from "../../utils/data";
import { SearchBarData } from "../../interfaces/interfaces";
import styles from "./SearchBar.module.scss";
import { useSearchParams } from "react-router-dom";

const SearchBar = () => {
  const lensIcon = getAsset(EAssetName.LENS);
  const data = getData(EData.SEARCH_BAR) as SearchBarData;

  const [searchParams, setSearchParams] = useSearchParams({ q: "" });

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    if (!value) {
      setSearchParams((prev) => {
        prev.delete(EParams.QUERY);
        return prev;
      });
    } else {
      setSearchParams((prev) => {
        prev.set(EParams.QUERY, value);
        return prev;
      });
    }
  };

  return (
    <div className="d-flex flex-row w-100">
      <div className={classNames(styles.icon)}>
        <img src={lensIcon} alt={lensIcon} />
      </div>
      <div className={classNames(styles.input)}>
        <input
          type="text"
          placeholder={data.placeholder}
          onChange={handleOnChange}
          value={searchParams.get(EParams.QUERY) || ""}
        />
      </div>
    </div>
  );
};

export default SearchBar;
